<div id="refDest" class="container mb-4" name="refDest">
  <div class="row justify-content-center">
    <h2 class="text-center mt-4">
      {{ 'byt_home_your_destinations' | translate }}
    </h2>
  </div>
</div>
<div
  id="destinations"
  class="container mb-5"
  *ngIf="item | async as destinations; else loading">
  <div class="row">
    <ng-container *ngFor="let destination of destinations">
      <a
        [routerLink]="['/trails', destination.slug]"
        class="col-12 col-md-6 col-lg-4 px-3 px-md-2 py-2">
        <div
          class="card text-center px-1"
          [defaultImage]="defaultImage"
          [lazyLoad]="destination.image_square | getImageUrlDirectus">
          <div class="card-content px-3 px-xl-4">
            <h3 class="card-title mb-4">
              {{ destination | getTextDirecuts : 'name' : currLang }}
            </h3>
            <a
              [routerLink]="['/trails', destination.slug]"
              class="btn btn-outline-white btn-small mb-4"
              >{{ 'byt_trail_more' | translate }}</a
            >
          </div>
        </div>
      </a>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <div class="row vh-50 d-flex justify-content-center align-items-center">
    <div class="col-12">
      <app-spinner></app-spinner>
    </div>
  </div>
</ng-template>
